import styled from 'styled-components';
import { BlockSelectField } from '@common/components/FormElements';

export const Select = styled(BlockSelectField)`
  margin-bottom: 14px;
  & .select-error {
    margin-top: ${({ theme }) => theme.spaces.space2};
    font-size: 16px;
  }
`;

export const ChildAgesContainer = styled.div`
  display: grid;
  grid-column-gap: 10px;
  grid-template-columns: repeat(2, calc(50% - 5px));
`;

export const SpecialLabel = styled.label`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;
